/**
 * Validates the content of a text input field to be a valid email address.
 * If validation fails then
 * - the element containing this directive receives a css class "errorInput" and
 * - sets the value "emailValid" in the parent controller scope to "false".
 *
 * Sample HTML usage:
 * <input type="text" d-validate-email/>
 *
 * Sample usage of "emailValid" value in controller scope:
 * - display an additional HTML element like <div ng-show="hasEmailError()">error text</div>
 * - parent controller function:
 *
 * $scope.hasEmailError = function () {
 *       return !$scope.emailValid;
 *   };
 */

import { EMAIL_VALIDATOR } from '@farmnet/validators';

angular.module('cfn').directive('dValidateEmail', function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      emailValid: '='
    },

    link: function(scope, elem, attrs, ctrl) {
      function validateEmail(email) {
        const emailPattern = EMAIL_VALIDATOR;
        elem.removeClass('errorInput');
        scope.$parent.emailValid = true;

        console.log('email-text: ' + email);

        if (email && !email.match(emailPattern)) {
          elem.addClass('errorInput');
          scope.$parent.emailValid = false;
        }
        return email;
      }

      ctrl.$parsers.unshift(function(viewValue) {
        console.log('viewValue:');
        console.log(viewValue);
        return validateEmail(viewValue, 0);
      });

      ctrl.$formatters.unshift(function(modelValue) {
        console.log('modelValue:');
        console.log(modelValue);
        return validateEmail(modelValue, 1);
      });
    }
  };
});
